module.exports = __webpack_public_path__ + "b55721a59f693ffb8690234d56c218cf.svg";